import type LoginDTO from '../repositories/auth/dto/login.dto'
import type AuthController from '../controllers/auth/auth.controller'
import { BusinessError } from '@trading/infrastructure/src/api/errorTypes'
import type RegisterDTO from '../repositories/auth/dto/register.dto'
import type { AuthPayload } from "../models/auth.model";
import type SsoDTO from "../repositories/auth/dto/sso.dto";

export default class AuthService {
  constructor(private auth: AuthController) {
  }

  async login(params: LoginDTO): Promise<AuthPayload> {
    return await this.auth.loginRequest(params)
      .then(resp => {
        if (resp.data) {
          return resp.data
        }
        throw new BusinessError('При login пришёл не правильный ответ от сервера')
      })
      .catch(error => {
        throw error
      })
  }

  async loginByAccount(params: LoginDTO): Promise<AuthPayload> {
    return await this.auth.loginRequestByAccount(params)
      .then(resp => {
        if (resp.data) {
          return resp.data
        }
        throw new BusinessError('При login пришёл не правильный ответ от сервера')
      })
      .catch(error => {
        throw error
      })
  }

  async loginBySso(params: SsoDTO): Promise<AuthPayload> {
    return await this.auth.loginRequestBySso(params)
      .then(resp => {
        if (resp.data) {
          return resp.data
        }
        throw new BusinessError('При login пришёл не правильный ответ от сервера')
      })
      .catch(error => {
        throw error
      })
  }

  async register(params: RegisterDTO): Promise<AuthPayload | void> {
    try {
      return await this.auth.registerRequest(params)
        .then(resp => {
          if (resp.data) {
            return resp.data
          }
          throw new BusinessError('При register пришёл не правильный ответ от сервера')
        })
    } catch (error) {
      throw error
    }
  }

  async refresh(): Promise<AuthPayload | void> {
    try {
      return await this.auth.refreshRequest().then(resp => {
        if (resp.data) {
          return resp.data
        }
        throw new BusinessError('При refresh пришёл не правильный ответ от сервера')
      })
    } catch (error) {
      throw error
    }
  }


  async logout(): Promise<void> {
    try {
      await this.auth.logoutRequest()
    } catch (error) {
      throw error
    }
  }

}
